
import { debounce } from "lodash";
import { defineComponent } from "vue";
import { Filter } from "@/types/filter.type";
import { ClassificationImage } from "@/types/classificationImage.type";
import PageHeaderComponent from "../../components/PageHeader.component.vue";
import { getClassificationsImage } from "@/service/classificationImage.service";
import PageButtonsComponent from "@/components/PageButtons.component.vue";

export default defineComponent({
  components: { PageHeaderComponent, PageButtonsComponent },

  data() {
    return {
      entities: [] as ClassificationImage[],
      currentPage: 0 as number,
      rowPerPage: 10 as number,
      totalRows: 0 as number,
      query: "" as string,
      showEntityForm: false,
      showEntityInfo: false,
    };
  },
  created() {
    // - apply delay
    this.search = debounce(this.refreshEntities, 300);
  },
  mounted() {
    this.currentPage = 1;
    this.refreshEntities();
  },
  methods: {
    search(): void {
      this.refreshEntities();
    },

    /**
     * set page
     * @param page
     */
    changePaginationSize(size: number): void {
      this.rowPerPage = size;
      this.refreshEntities();
    },

    /**
     * change page
     * @param {number} page
     */
    changePaginationPage(page: number): void {
      this.currentPage = page;
      this.refreshEntities();
    },

    /**
     * refresh samplingPoint item from list items
     * @param item
     */
    async refreshEntities(item: ClassificationImage | undefined = undefined) {
      let index = -1;
      if (this.entities && item) {
        index = this.entities.findIndex((i) => i.id === item.id);
      }
      if (index !== -1 && item) {
        this.entities[index] = item;
      } else {
        const filter: Filter = {};
        if (this.query) {
          filter.multi = this.query;
        }

        filter.fields = {
          "samplingPoint.id": { operator: "equal", value: this.$route.query.samplingPoint },
        };

        const pagination = await getClassificationsImage(this.currentPage, this.rowPerPage, filter);

        this.totalRows = pagination.totalRows;
        this.entities = pagination.data;
      }
    },

    goToClassification(element: ClassificationImage, show: string) {
      if (element) {
        this.$router.push({
          path: `${this.$route.path}/imagelabel/`,
          query: {
            ...this.$route.query,
            type: show,
            classification: element.id,
          },
        });
      } else {
        this.$router.push({
          path: `${this.$route.path}/imagelabel/`,
          query: {
            ...this.$route.query,
            type: show,
          },
        });
      }
    },

    isDisabledCreateAndView() {
      return this.entities && this.entities.length > 0 && !this.entities[0].dateTime;
    },
  },
});
